import { updateSmoothScroll } from '../scroll-smoother'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)


// generate graphs
let grapshBlocks = $('.js-graph-block')
if (grapshBlocks.length){

  grapshBlocks.each((i, block)=> {

    let $block = $(block)
    let $catButtons = $block.find('.js-cat-b')
    let $graphC = $block.find('.js-graph')


    $catButtons.click(function(){
      changeActive($(this))
      let data = $(this).data('graph-columns')
      let topValue = $(this).data('top-value')
      let bottomValue = $(this).data('bottom-value')
      generateGraph(data, topValue, bottomValue)
    });

    $(document).ready(function () {
      $block.find('.js-cat-b').first().click()
    });

    function changeActive($this){
      let graphId = $this.data('graph-id')
      $catButtons.removeClass('active')
      $catButtons.each((i, el)=> {
        if ($(el).data('graph-id') === graphId) $(el).addClass('active')
      })
      $block.data('active-cat', graphId)
    }

    const generateGraph = (data, topValue, bottomValue) => {
      $graphC.animate({opacity: 0}, function(){

        $graphC.html('')
        let minVal = 999999999999999
        let maxVal = -99999999999999

        if (data){
          data.forEach((el)=> {
            if (el.value < minVal) minVal = parseFloat(el.value)
            if (el.value > maxVal) maxVal = parseFloat(el.value)
          })

          //let fullVal = maxVal + ((maxVal - minVal) / 100 * 30) // zoomed graph values
          //let lowVal = minVal - ((maxVal - minVal) / 100 * 60)

          let fullVal = topValue && bottomValue ? topValue : maxVal + (maxVal / 100 * 20)

          data.forEach((el)=> {
            //let height = ((parseFloat(el.value) - lowVal) / (fullVal - lowVal) * 100) // zoomed graph values
            let colHeight = 0
            if (topValue && bottomValue){
              colHeight = (parseFloat(el.value) - bottomValue) / (fullVal - bottomValue ) * 100
            } else {
              colHeight = parseFloat(el.value) / fullVal * 100
            }
            $graphC.append($(generateColumn(el.column_label, el.line_label, data.length, colHeight)))
          })

          $graphC.animate({opacity: 1}, function(){
            if (!$graphC.data('first-init-flag')) {
              animateGraphHeights($graphC[0])
            } else {
              $graphC.data('first-init-flag', 0)
            }
          })
        }

        updateSmoothScroll()

      })
    }


    function generateColumn(title, lineTitle, total, height){
      return '<div class="column" style="width: '+ (100 / total) +'%;" >' +
                '<div class="borders-c">' +
                  '<div></div>' +
                  '<div></div>' +
                  '<div></div>' +
                  '<div></div>' +
                '</div>' +
                '<div class="data-col" data-height="'+ height +'" >' +
                  '<div class="title">'+ title +'</div>' +
                  '<div class="line-title">'+ lineTitle +'</div>' +
                '</div>' +
              '</div>'
    }


  }) // end graphs foreach
}

// animate colons up, when in screen
document.querySelectorAll('.js-animate-when-in-screen').forEach(function (el) {

    ScrollTrigger.create({
      trigger: el,
      start: "top bottom-=200px", // el top, screen bottom
      once: true,
      onEnter: () => animateGraphHeights(el)
    });

})

function animateGraphHeights(el){
  let colons = el.querySelectorAll('.data-col')
  let delay = 200
  colons.forEach((el, i) => {
    let height = el.getAttribute('data-height')
    setTimeout(function(){
      el.style.height = height + '%'
      el.querySelector('.title').style.opacity = 1
    }, delay)
    delay+= 200
  })
}

